import React from 'react';
import { Container, Button, Alert } from 'react-bootstrap';
import { ArrowClockwise } from 'react-bootstrap-icons';
import AboutLayout from '../../layouts/AboutLayout';
import { House } from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';

export default function ISADgCollectionError({ acervo, message }) {
	return (
		<AboutLayout
			title={'Error'}
			backgroundImage={acervo.agency}
			agency={acervo.agency}
			subtitleIcon={<House />}
		>
			<Container>
				<Alert variant='danger' className='mt-3'>
					<Alert.Heading>Hubo un error</Alert.Heading>
					<p>{message}</p>
					<hr />
					<div className='d-flex justify-content-end gap-3'>
						<Link
							to={`/glifos/agency/${acervo.code}`}
							className='btn btn-outline-danger'
						>
							<House /> Regresar
						</Link>
						<Button
							onClick={() => window.location.reload()}
							variant='outline-danger'
						>
							<ArrowClockwise /> Recargar
						</Button>
					</div>
				</Alert>
			</Container>
		</AboutLayout>
	);
}
